import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  paperRoot: {
    maxWidth: 400,
  },
  content: {
    width: 300,
    padding: theme.spacing(2.5),
  },
  dialogTitle: {
    padding: 0,
    marginBottom: theme.spacing(1.25),
  },
  boxTitle: {
    display: "flex",
  },
  titleText: {
    marginLeft: theme.spacing(1.25),
    marginRight: theme.spacing(3),
  },
  selectBox: {
    margin: `${theme.spacing(2.5)} 0`,
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    "& .MuiFormControl-root": {
      gap: "10px",
    },
  },
  rightAdornment: {
    display: "flex !important",
    alignItems: "center",
  },
  note: {
    color: theme.palette.grey[500],
  },
  actions: {
    padding: 0,
    justifyContent: "space-between",
    "& button": {
      width: "127px",
    },
  },
  icon: {
    color: theme.palette.events.bluePrimary,
    "& rect": {
      color: theme.palette.events.blueShade2,
    },
  },
}));
